import { useEffect } from 'react'
import facebookPixel from '../../utils/facebookPixel'
import googleAnalytics from '../../utils/googleAnalytics'

// A redirect-on-mount page (e.g. /dining → /signin for a guest) changes the route within a
// few ms; page views are counted once the route has settled, so only the final page counts.
const PAGE_VIEW_SETTLE_MS = 250

// Loads the page's Meta pixel and GA4 property and counts page views on them. Renders
// nothing. Used by the event page (event ids, which already fall back to the account's) and
// by the seller pages (the seller account's ids).
//
// Each mount re-points the tracking utils at THIS page's ids, so a visitor who goes seller
// page → event page → back has every PageView / InitiateCheckout / Purchase sent to the
// page's own pixel and property only (see facebookPixel.js / googleAnalytics.js).
//
// `pageKey` identifies the page being viewed while this stays mounted (the pathname on the
// seller pages, the event id on the event page). When it changes:
// - Meta gets an explicit PageView — the pixel has no history tracking of its own.
// - GA4 does NOT: its enhanced measurement ("page changes based on browser history events",
//   on by default) already emits a page_view for every client-side navigation, so an explicit
//   one here would double count. GA4 gets one explicit page_view per property load only
//   (the plugin sends none on config).
export default function TrackingTags({ pixelId, measurementId, pageKey = null }) {
    // Each tracker reacts to its own id only: a page that changes the pixel but keeps the
    // GA4 property must not re-send a GA4 page_view (enhanced measurement already did).
    useEffect(() => {
        googleAnalytics.init(measurementId)
        const timer = setTimeout(() => googleAnalytics.pageView(), PAGE_VIEW_SETTLE_MS)
        return () => clearTimeout(timer)
    }, [measurementId])

    useEffect(() => {
        facebookPixel.init(pixelId)
        const timer = setTimeout(() => facebookPixel.pageView(), PAGE_VIEW_SETTLE_MS)
        return () => clearTimeout(timer)
    }, [pixelId, pageKey])

    return null
}
